import { gql } from '@apollo/client';

export const updatePasswordGql = gql`
  mutation updatePassword($input: UpdatePasswordDto!) {
    updatePassword(input: $input) {
      success
    }
  }
`;
